import React from 'react';
import PropTypes from 'prop-types';
import {ZoomInIcon, ZoomOutIcon} from './Icons';
import {ZoomDropdown} from './ZoomDropdown';
import './style.scss';

/**
 * ZoomMenu:
 *  - Component renders the ZoomIn/Out Controls for PopupZoomImage component
 */
export function ZoomMenu(props) {
  const onDropdownChange = (option) => props.setZoom(option.value);

  const zoomIN = () => props.setZoom(props.zoomValue + props.zoomRate);

  const zoomOUT = () => props.setZoom(props.zoomValue - props.zoomRate);

  const setZoomInDisabled = (className) => {
    if (props.zoomValue >= props.maxZoom) {
      return className + ' disabled';
    } else {
      return className;
    }
  };

  const setZoomOutDisabled = (className) => {
    if (props.zoomValue <= props.minZoom) {
      return className + ' disabled';
    } else {
      return className;
    }
  };

  return (
    <div className='zoomMenuBlock'>
      <div className={setZoomInDisabled('zoomMenuBlock_left')} onClick={zoomIN}>
        <ZoomInIcon className='icon icon-zoomIn' />
      </div>
      <div className='zoomMenuBlock_middle'>
        <ZoomDropdown
          value={props.zoomValue}
          options={props.dropdownOptions}
          onChange={onDropdownChange}
        />
      </div>
      <div
        className={setZoomOutDisabled('zoomMenuBlock_right')}
        onClick={zoomOUT}>
        <ZoomOutIcon className='icon icon-zoomOut' />
      </div>
    </div>
  );
}

ZoomMenu.propTypes = {
  /**
   * Function to set the zoom value
   */
  setZoom: PropTypes.func,
  /**
   * Current zoom value
   */
  zoomValue: PropTypes.number,
  /**
   * Rate at which zoom needs be increased /decreased
   */
  zoomRate: PropTypes.number,
  /**
   * max value for zoom
   */
  maxZoom: PropTypes.number,
  /**
   * min value for zoom
   */
  minZoom: PropTypes.number,
  /**
   * Option to show on dropdown
   */
  dropdownOptions: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * value of the dropdown option
       */
      value: PropTypes.number,
      /**
       * Label of options
       */
      label: PropTypes.string,
    })
  ),
};
